export default __webpack_public_path__ + "static/multi-ai-f4b4b2e1a1144b41bf2adcd8a7489d9d.png";